












import { TyMarketplace } from "@/classes/TayehApi";
import { GetTayehMarketplaceShopResponse } from "@/classes/TayehApi/TyMarketplace";
import MarketplaceShopCard from './MarketplaceShopCard.vue'
import {Component, Vue} from "vue-property-decorator";

@Component({
    components: {
        MarketplaceShopCard
    }
})
export default class FreshShops extends Vue{
    shops: GetTayehMarketplaceShopResponse[] = [];

    async getMarketPlaceFreshShops () {
        const res = await TyMarketplace.getTyMarketplaceShops();
        this.shops = res.data?.shops;
    }
    mounted () {
        this.getMarketPlaceFreshShops()
    }
}
